<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-2 border-2 border-base-200 rounded-md p-4">
      <div class="text-secondary text-2xl font-bold">Allgemein</div>

      <div class="grid grid-cols-2 justify-between gap-4 items-center">
        <label-component label="Identifier" postfix="(identifier)" />
        <input-component type="text" placeholder="Identifier" v-model="claim.identifier" />
      </div>

      <div class="grid grid-cols-2 justify-between gap-4 items-center">
        <label-component label="Name" postfix="(name)" />
        <input-component type="text" placeholder="Name" v-model="claim.name" />
      </div>

      <div class="grid grid-cols-2 justify-between gap-4 items-center">
        <label-component label="Beschreibung" postfix="(description)" />
        <input-component type="text" placeholder="Beschreibung" v-model="claim.description" />
      </div>
    </div>

    <div class="self-end">
      <button-component fa-icon="fa-regular fa-floppy-disk" @click="$emit('save', claim)"></button-component>
    </div>
  </div>
</template>

<script>
import LabelComponent from "@/components/LabelComponent";
import InputComponent from "@/components/InputComponent";
import ButtonComponent from "@/components/ButtonComponent";
export default {
  name: "UpsertClaimComponent",
  components: { ButtonComponent, InputComponent, LabelComponent },
  props: ["modelValue"],
  data() {
    return {
      claim: undefined
    };
  },
  created() {
    this.claim = this.modelValue;
  },
  watch: {
    claim: {
      handler() {
        this.$emit("update:modelValue", this.claim);
      },
      deep: true
    }
  }
};
</script>

<style scoped>

</style>